import { PointsAccount } from 'src/models/users/pointsAccount';
import { Points } from './points';
export class PointsAccountHistory extends Points{
    id: number;
    createdAt: string;
    spentPoints: number;
    pointsAccountId: number;
}